export default {"src":"/_next/static/media/delivery.b41a7eaa.svg","height":176,"width":176};